<template>
  <!-- <div>自营订单列表 </div> -->

  <div class="shop" v-loading="loading">
    <div class="top">
      <el-input class="search input" size="small" v-model="form.username" placeholder="用户手机号查询" clearable></el-input>
      <el-input class="search input" size="small" v-model="form.consignee_mobile" placeholder="收货人手机号查询" clearable>
      </el-input>
      <el-input class="search input" size="small" v-model="form.order_no" placeholder="订单号查询" clearable></el-input>
      <el-input class="search input" size="small" v-model="form.out_order_no" placeholder="外部订单号查询" clearable>
      </el-input>
      <el-input class="search input" size="small" v-model="form.uid" placeholder="下单用户ID查询" clearable></el-input>
      <el-input class="search input" size="small" v-model="form.product_name" placeholder="商品名称" clearable></el-input>
      <el-select style="width: 120px" size="small" v-model="form.status" filterable class="search" placeholder="订单状态">
        <el-option label="全部" :value="0">全部</el-option>
        <el-option label="待付款" :value="1"></el-option>
        <el-option label="待发货" :value="5"></el-option>
        <el-option label="待收货" :value="8"></el-option>
        <el-option label="已完成" :value="10"></el-option>
        <!-- <el-option label="退款申请中"
          :value="4"></el-option> -->
        <el-option label="已关闭" :value="20"></el-option>
      </el-select>

      <!-- <el-select
        style="width:100px;margin-right:10px"
        size="small"
        v-model="form.refund_status"
        filterable
        class="search"
      >
        <el-option label="全部" :value="0"></el-option>
        <el-option label="退款中" :value="5"></el-option>
      </el-select> -->
      <el-date-picker v-model="form.start_time" type="date" class="picker" style="width: 142px; margin-left: 10px"
        value-format="yyyy-MM-dd" size="small" placeholder="选择开始时间"></el-date-picker>
      <span class="guodu">~</span>
      <el-date-picker v-model="form.end_time" class="picker" type="date" style="width: 142px; margin-right: 10px"
        size="small" value-format="yyyy-MM-dd" placeholder="选择结束时间">
      </el-date-picker>
      <el-button size="small" type="primary" @click="exportPrivateOrder">导出数据</el-button>
      <el-button class="search" size="small" type="primary" @click="searchOrderData">搜索</el-button>
      <el-button class="search" size="small" type="primary" @click="cancelOrdersFn">批量取消订单</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%" max-height="610" :cell-style="tc" :header-cell-style="tccolor"
      v-loading="loading">
      <el-table-column label="订单编号" prop="order_no" width="140"></el-table-column>
      <el-table-column label="外部订单编号" prop="out_order_no" width="140"></el-table-column>
      <el-table-column label="订单类型" prop="order_type_name" width="140"></el-table-column>
      <!-- <el-table-column
        label="商品ID"
        prop="product_id"
        width="100"
      ></el-table-column> -->
      <el-table-column label="商品信息" prop="title" width="240"></el-table-column>
      <el-table-column label="类目" prop="cate_name" width="241"></el-table-column>
      <el-table-column label="订单来源" prop="order_source_name" width="140"></el-table-column>
      <el-table-column label="下单用户ID" prop="uid" width="120"></el-table-column>
      <!-- <el-table-column label="商品SKU" prop="sku"></el-table-column> -->
      <el-table-column label="订单原价" width="140">
        <template slot-scope="scope">
          {{ scope.row.origin_price }}(元)</template>
      </el-table-column>
      <el-table-column label="红包抵扣" width="140">
        <template slot-scope="scope">
          {{ scope.row.red_packet_discount_price }}(红包)
        </template>
      </el-table-column>
      <el-table-column label="商品实付">
        <template slot-scope="scope"> ¥{{ scope.row.actual_amount }} </template>
      </el-table-column>
      <!-- <el-table-column label="商品实付">
        <template slot-scope="scope">
          ¥{{ scope.row.product_total_price }}
        </template>
      </el-table-column> -->
      <el-table-column label="实付运费">
        <template slot-scope="scope">
          ¥{{ scope.row.freight_amount }}
        </template>
      </el-table-column>
      <el-table-column label="成本运费">
        <template slot-scope="scope">
          ¥{{ scope.row.supply_freight_price }}
        </template>
      </el-table-column>
      <el-table-column label="成本价">
        <template slot-scope="scope">
          ¥{{ scope.row.supply_min_price }}
        </template>
      </el-table-column>
      <el-table-column label="来源">
        <template slot-scope="scope">
          {{ scope.row.scm_sign }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="order_status_name">
      </el-table-column>
      <el-table-column label="创建时间" prop="created_at" width="144"></el-table-column>
      <el-table-column label="开票状态" prop="is_invoice"></el-table-column>
      <el-table-column label="税收分类" prop="goods_class"></el-table-column>
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="goOrderDetail(scope.row.order_no)">详情</el-button>
          <el-button size="mini" @click="showOrderRemark(scope.row.id)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination background @current-change="pageChange" :current-page="form.page" :page-size="form.size"
          layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-col>

    <!--订单备注-->
    <jdialog title="订单备注" :visible.sync="isShowOrderremark" width="640px">
      <el-form :model="remarkform" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label='订单状态备注'
          prop='remark'>
          <el-select style="width:180px;"
            size='small'
            v-model="remarkform.remark"
            filterable
            placeholder="请选择">
            <el-option label="退款申请中"
              :value="0">退款申请中</el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in activities" :key="index" :color="activity.color">
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
          <el-input type="textarea" :rows="4" class="remarkarea" placeholder="请输入备注信息" v-model="remarkform.mark">
          </el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowOrderremark = false">取消</el-button>
        <el-button size="mini" type="primary" @click="certainRefundClick">确定</el-button>
      </div>
    </jdialog>
    <!--批量取消订单-->
    <jdialog title="批量取消订单" :visible.sync="isShowOrdersCancel" width="700px">
      <el-form label-width="100px" class="demo-ruleForm">

        <el-form-item>
          批量处理电费退款 现有{{cancelOrdersNum}}条数据
          <el-input placeholder="请输入权限密码" v-model="cancelPass" show-password>
          </el-input>
          <el-input type="textarea"  class="cancelarea" :rows="10" placeholder="请输入单号，每一个单号一行" @input="cancelOrdersInput" v-model="cancelOrders">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="align">
        <el-button size="mini" @click="isShowOrdersCancel = false">取消</el-button>
        <el-button size="mini" type="primary" @click="sureCancelOrdersFn">确定</el-button>
      </div>
    </jdialog>
  </div>
</template>

<script>
import {
  orderSupplySearch,
  orderrefundlogCreate,
  orderrefundloglist,
  cancelOrdersAjax
} from '@/api/autarky'
import { API_BASE_URL } from '@/config'
export default {
  data() {
    return {
      loading: false,
      form: {
        status: 0,
        start_time: '',
        end_time: '',
        refund_status: 0,
        order_no: '',
        out_order_no: '',
        username: '',
        consignee_mobile: '',
        cate_id: '',
        product_id: '',
        is_export: '',
        page: 1,
        size: 15,
        filename: '',
        uid: '',
        product_name: '',
      },
      total: 0,
      tableData: [],

      //显示订单备注
      isShowOrderremark: false,
      remarkform: {
        mark: '',
        order_id: '',
      },
      activities: [],
      //显示批量取消订单
      isShowOrdersCancel: false,
      cancelPass:'',
      cancelOrders:'',
      cancelOrdersNum: 0
    }
  },
  mounted() {
    this.form.cate_id = this.$route.query.cate_id
    this.form.product_id = this.$route.query.product_id
    this.getorderSupplySearchListData()
  },
  methods: {
    //导出数据
    exportPrivateOrder() {
      this.form.is_export = 1
      this.getorderSupplySearchListData()
    },
    //搜索
    searchOrderData() {
      this.getorderSupplySearchListData()
    },
    cancelOrdersFn() {
      this.isShowOrdersCancel = true
    },
    cancelOrdersInput(){
      const numberOfLines = this.cancelOrders.split('\n').length;
      this.cancelOrdersNum = numberOfLines
    },
    sureCancelOrdersFn() {
      this.postCancelOrdersAjaxFn()
    },
    async postCancelOrdersAjaxFn() {
      let res = await cancelOrdersAjax({pass: this.cancelPass,order_sns: this.cancelOrders})
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.isShowOrdersCancel = false
      } else {
        this.$message.error(res.message)
      }
    },
    pageChange(page) {
      this.form.page = page
      //申请更多销售日志数据
      this.getorderSupplySearchListData()
    },
    //前往订单详情
    goOrderDetail(order_no) {
      console.log(order_no)
      this.$router.push({
        path: './preorderdetail',
        query: { order_no: order_no },
      })
    },
    //显示备注
    showOrderRemark(id) {
      this.remarkform.order_id = id
      this.activities = []
      this.isShowOrderremark = true
      this.getorderrefundloglistData(id)
    },
    certainRefundClick() {
      this.getorderrefundlogCreateData()
    },
    //获取自营订单列表数据
    async getorderSupplySearchListData() {
      if (this.form.status == 0) {
        this.form.status = ''
      }
      if (this.form.refund_status == 0) {
        this.form.refund_status = ''
      }
      if (!this.form.product_id) {
        this.form.product_id = ''
      }
      if (!this.form.cate_id) {
        this.form.cate_id = ''
      }
      if (this.form.start_time == null) {
        this.form.start_time = ''
      }
      if (this.form.end_time == null) {
        this.form.end_time = ''
      }
      var url =
        'status=' +
        this.form.status +
        '&start_time=' +
        this.form.start_time +
        '&end_time=' +
        this.form.end_time +
        '&refund_status=' +
        this.form.refund_status +
        '&order_no=' +
        this.form.order_no +
        '&out_order_no=' +
        this.form.out_order_no +
        '&username=' +
        this.form.username +
        '&uid=' +
        this.form.uid +
        '&consignee_mobile=' +
        this.form.consignee_mobile +
        '&cate_id=' +
        this.form.cate_id +
        '&product_id=' +
        this.form.product_id +
        '&product_name=' +
        this.form.product_name +
        '&is_export=' +
        this.form.is_export +
        '&page=' +
        this.form.page

      let res = await orderSupplySearch(url)
      if (res.code === 10000) {
        if (this.form.is_export == 1) {
          this.form.is_export = 0
          this.loading = true
          this.exportOut(res.data.page, res.data.filename)
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.form.is_export = ''
        this.$message.error(res.message)
      }
    },

    async exportOut(page, filename) {
      var url =
        'status=' +
        this.form.status +
        '&start_time=' +
        this.form.start_time +
        '&end_time=' +
        this.form.end_time +
        '&refund_status=' +
        this.form.refund_status +
        '&order_no=' +
        this.form.order_no +
        '&out_order_no=' +
        this.form.out_order_no +
        '&username=' +
        this.form.username +
        '&uid=' +
        this.form.uid +
        '&consignee_mobile=' +
        this.form.consignee_mobile +
        '&cate_id=' +
        this.form.cate_id +
        '&product_id=' +
        this.form.product_id +
        '&product_name=' +
        this.form.product_name +
        '&is_export=1&page=' +
        page +
        '&filename=' +
        filename
      let res = await orderSupplySearch(url)
      if (res.code === 10000) {
        if (res.data.code === 2) {
          this.exportOut(res.data.page, res.data.filename)
        } else if (res.data.code === 1) {
          this.loading = false
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data.download_token}`
          )
        } else {
          this.loading = false
          this.$message.error(res.data.message)
        }
      } else {
        this.loading = false
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    //订单日志创建
    async getorderrefundlogCreateData() {
      let res = await orderrefundlogCreate(this.remarkform)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.isShowOrderremark = false
      } else {
        this.$message.error(res.message)
      }
    },

    //订单日志列表
    async getorderrefundloglistData(id) {
      let res = await orderrefundloglist(id)
      if (res.code === 10000) {
        if (res.data.length != 0) {
          res.data.map((obj) => {
            this.activities.push({
              content: obj.mark + '      ' + obj.created_at,
              color: '#f4222d',
            })
          })
        }
      } else {
        this.$message.error(res.message)
      }
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
  },
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;

  .top {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 20px;

    .search {
      margin-left: 10px;
    }

    .input {
      width: 140px;
    }

    .guodu {
      line-height: 30px;
    }
  }

  .align {
    text-align: center;
    padding-bottom: 20px;
  }

  .pagination {
    float: right;
    margin-top: 12px;
  }

  .demo-ruleForm {
    padding: 20px;

    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
    .cancelarea{
      margin-top: 20px;
      height: 200px;
    }
  }
  ::v-deep.el-loading-spinner {
    top: 30% !important;
  }
}
</style>
